import {GPItem} from "./gp-item.js";
import {getGPTransFunc} from "./gp-translations";

let trans = getGPTransFunc("gp-uploadcustomobject");

export class GPCustomObject extends GPItem
{
    constructor (id, typeId, x, y, scale, flip, temp, fixedObject) {
        super();
        this.id = id;
        this.typeId = typeId;
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.horizontalFlip = flip;
        this.zindex = 0;
        this.relativeBaseOffset = 0;
        this.actualBaseOffset = 0;
        this.imageWidth = null;
        this.imageHeight = null;
        this.temp = temp;
        this.originItemInstance = null;
        this.fixedObject = fixedObject ? fixedObject : false;

        this.supportsFlip = true;
        this.supportsInfo = false;
        this.supportsAdjust = false;
        this.supportsRotate = false;

        this.data = GP.customObjectsById[typeId];
    }
    
    getName () {
        return this.data.name ? this.data.name : trans("Custom object");
    }

    getHeight  () {
        return 100;
    }
    
    getPathForImage () {
        if (this.temp)
            return this.data.imgData;
        return this.data.staticGetPathForImage();
    }
    
    getPathForThumb () {
        if (this.temp)
            return this.data.imgData;
        return this.data.staticGetPathForThumb();
    }
     
    itemImageScale (projy) {
        if (this.fixedObject) return this.scale;

        var plantSize = this.getHeight();
        var scale = this.scaleAccordingToHorizon(projy);
        if (scale <=0.1) scale = 0.1;
        scale = scale*plantSize/(this.imageHeight);
        scale = scale * this.scale;
        return scale;
    }

    toJSON() {
        return {
            id: this.id,
            typeId: this.typeId,
            x: this.x,
            y: this.y,
            s: this.scale,
            f: this.horizontalFlip,
            fixed: this.fixedObject
        }
    }
}